import { render, staticRenderFns } from "./DispatchJob.vue?vue&type=template&id=63b9ab48&scoped=true&"
import script from "./DispatchJob.vue?vue&type=script&lang=js&"
export * from "./DispatchJob.vue?vue&type=script&lang=js&"
import style0 from "./DispatchJob.vue?vue&type=style&index=0&id=63b9ab48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b9ab48",
  null
  
)

export default component.exports